import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IEnableWorkbookAccelerationParams {
  targetIds: string[];
  scheduleId: string;
}

export class EnableWorkbookAccelerationRequest extends Request<IEnableWorkbookAccelerationParams, IResult> {
  constructor(params: IEnableWorkbookAccelerationParams) {
    super('enableWorkbookAcceleration', params);
  }
}
